<!--
    Name:			TimePicker.vue
    Description:	Show a timepicker for the use of the warmingtray
-->

<template>
    <div class="timeContainer">
        <span @click="hourUp(1)" class="icon-up-open btnUp"></span><span class="mid"></span><span @click="minuteUp(1)"  class="icon-up-open btnUp"></span>
        <span> {{formattedHour}}</span><span  class="mid">:</span><span>{{formattedMinute}}</span>
        <span @click="hourUp(-1)" class="icon-up-open btnDown"></span><span class="mid"></span><span @click="minuteUp(-1)" class="icon-up-open btnDown"></span>
    </div>
    
</template>

<script>

    import timemanager from '../../repositories/TimeManager';

    const timePicker = {
        name: 'timePicker',

        props: {
            value: {
                type: [Date],
                default: null,
            },
        },

        computed: {
            hour() {
                return this.value.getHours();
            },
            minute() {
                return this.value.getMinutes();
            },
            
            formattedHour() {
                return this.hour < 10 ? '0' + this.hour : this.hour;
            },
            formattedMinute() {
                return this.minute < 10 ? '0' + this.minute : this.minute;
            }

        },

        methods: {                    

            emit() {
                const dateTime = new Date(this.value);
                this.$emit('input', dateTime);
            },

            hourUp(step) {       
                timemanager.addHours(this.value, step);
                
                this.emit();
            },
            minuteUp(step) {
                timemanager.addMinutes(this.value, step);
                
                this.emit();
            }

        }

    }

    export { timePicker as default };

</script>
<style>
   

</style>